export default __webpack_public_path__ + "static/media/btn-color-se_se@2x.52d1d513.png";